function RecommendedPosts( data, Link){

    return(

       <section on className="flat_overview mob">
          <h4 className="releted-head"> Recommended Posts </h4>
          
          <div className="promo-section relet-blog-sec">
            {data?.recommended?.map((post, index) => (
              <div
                className="promo-card"
                key={index.id} >
                <img
                  src={post?.media}
                  alt={post?.name}
                  className="promo-image pointer-crusser relet-blog-img-sec"
                />
                <div >
                  <p className="relatedpost-mob">
                    {post?.name
                      ? post?.name.substring(0, 40) + (post?.name.length > 40 ? "..." : "")
                      : ""}
                  </p>
                </div>

                <div className="txt_btn_recomend">
                  <p className="reletepost-mob-poston">
                    Posted on{" "}
                    {new Date(post?.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                  <Link to={`/blog/${post?.action_url}`} className="releted-readmore">
                    <u>Read More</u>
                  </Link>
                </div>
              </div >
            ))}
          </div >
        </section>

       )

}
export default RecommendedPosts;